import Player from "../../models/player";

export const state = {
	allPlayers: [],
	selectedPlayerId: "",
	recordingPlayerSearch: "",
	newPlayer: new Player({}),
	playerSortVal: "none",
};
